// extracted by mini-css-extract-plugin
module.exports = {"main-component":"meetTheTeam_main-component__1aWS0"};